/**
 * Converts a hex color to RGB values as a comma-separated string
 * @param hex - Hex color code (with or without #)
 * @returns RGB values as "r, g, b" string for use in rgba() CSS function
 * @example hexToRgb("#ff0000") => "255, 0, 0"
 */
export const hexToRgb = (hex: string): string => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? `${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}`
    : "0, 255, 136"; // Default fallback color = brand green
};
